<app-nav-top-bar #navtopbar [showTopbarConnectedUser]="showNav" (showMenuEmitter)="onShowMenu($event)"></app-nav-top-bar>

<mat-sidenav-container class="principal-container" autosize="true">
    <mat-sidenav class="menu-sidenav" mode="side" opened="true" [ngClass]="{ 'menu-sidenav-hidden': !showNav }">
        @if (showNav) {
            <app-nav-menu [isExpanded]="showMenu"></app-nav-menu>
        }
    </mat-sidenav>

    <div class="principal-sidenav-content">
        <router-outlet></router-outlet>
    </div>
</mat-sidenav-container>
<ngx-spinner class="spinner" bdColor="rgba(0, 0, 0, 0.8)" size="large" type="timer" [fullScreen]="true"></ngx-spinner>
